import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { QUICK_ACTIONS_LEGEND_ROW_ID } from "./releaseTableHelpers";

const formatTrackCount = (count) => {
  if (count == null) return "-";
  return count === 1 ? "1 Track" : `${count} Tracks`;
};

const formatExclusiveReleaseDate = (exclusiveDate, exclusiveShop) => {
  if (!exclusiveDate) {
    return "No exclusive date";
  }

  const shopName = exclusiveShop?.name;
  return shopName ? `${exclusiveDate} (${shopName})` : exclusiveDate;
};

const ReleaseExpandedDetails = ({ row }) => (
  <div className="release-row-details">
    <div className="release-row-details-fields">
      <div className="release-row-details-item">
        <span className="release-row-details-label">Tracks</span>
        <span className="release-row-details-value">{formatTrackCount(row.get_mixes_number)}</span>
      </div>
      <div className="release-row-details-item">
        <span className="release-row-details-label">UPC</span>
        <span className="release-row-details-value">{row.ean || "-"}</span>
      </div>
      <div className="release-row-details-item">
        <span className="release-row-details-label">Official Release Date</span>
        <span className="release-row-details-value">{row.official_date || "-"}</span>
      </div>
      <div className="release-row-details-item">
        <span className="release-row-details-label">Exclusive Release Date</span>
        <span className="release-row-details-value">
          {formatExclusiveReleaseDate(row.exclusive_date, row.exclusive_shop)}
        </span>
      </div>
    </div>
  </div>
);

const ReleaseListLayoutOne = ({
  baseProps,
  displayTableData,
  defaultSorted,
  rowHighlightStyle,
  onTableChange,
}) => (
  <div className="release-table-wrap">
    <BootstrapTable
      rowClasses={rowHighlightStyle}
      {...baseProps}
      data={displayTableData}
      bordered={false}
      remote={{ sort: true }}
      defaultSorted={defaultSorted}
      onTableChange={onTableChange}
      classes="release-list-table"
      expandRow={{
        showExpandColumn: true,
        expandByColumnOnly: true,
        expandColumnPosition: "right",
        nonExpandable: [QUICK_ACTIONS_LEGEND_ROW_ID],
        parentClassName: "release-row-expanded",
        className: "release-row-expand-cell",
        expandHeaderColumnRenderer: () => null,
        expandColumnRenderer: ({ expanded, expandable }) => {
          if (!expandable) {
            return null;
          }
          return (
            <span className="release-expand-toggle" aria-hidden="true">
              <i className={`fas fa-chevron-${expanded ? "down" : "right"}`} />
            </span>
          );
        },
        renderer: (row) => <ReleaseExpandedDetails row={row} />,
      }}
    />
  </div>
);

export default ReleaseListLayoutOne;
